import {
  get,
  post,
  remove,
  patch,
  PostOptions,
} from '../apiService/api.service'
import { AxiosResponse } from 'axios'
import axiosInstance from '@/services/axiosInstance/axiosInstance'
import { getENVData } from '@/configs/enviornment'
import type {
  BillSummaryResponse,
  PaymentMethodsResponse,
} from '../types/api.types'

export const fetchRoles = async () => {
  const url = `/users/getRoles`
  const result = get(url)
  return result
}

export const createRole = async (payload: Record<string, unknown>) => {
  const url = `/users/createRole`
  const result = post(url, payload)
  return result
}

export const createUser = async (payload: Record<string, unknown>) => {
  const url = `/users/createUser`
  const result = post(url, payload)
  return result
}

export const updateUser = async (payload: Record<string, unknown>) => {
  const url = `/users/update-user`
  const result = post(url, payload)
  return result
}

export const deleteUser = async (id: string) => {
  const url = `/management/users/delete-user?userId=${id}`
  const result = remove(url)
  return result
}
export const getServiceProviderCount = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/services/providers`
  const result = post(url, payload, { skipHeader: true })
  return result
}
export const getSavedSites = async () => {
  const url = `/management/users/site-preferences/list`
  const result = get(url, { skipHeader: true })
  return result
}
export const createSavedSites = async (payload: Record<string, unknown>) => {
  const url = `/management/users/site-preferences/list`
  const result = post(url, payload, { skipHeader: true })
  return result
}
export const deleteSavedSite = async (id: string) => {
  const url = `/management/users/site-preferences/list/?id=${id}`
  const result = remove(url)
  return result
}
export const getServiceTypeCount = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/services/types`
  const result = post(url, payload, { skipHeader: true })
  return result
}
export const deleteRole = async (id: { roleId: string }) => {
  const url = `/users/removeRole`
  const result = remove(url, id)
  return result
}

export const fetchPermissions = async () => {
  const url = `/users/getPermissions`
  const result = get(url)
  return result
}

export const createPermissions = async (payload: Record<string, unknown>) => {
  const url = `/users/createPermission`
  const result = post(url, payload)
  return result
}

export const deletePermission = async (id: string) => {
  const url = `/users/deletePermission/${id}`
  const result = remove(url)
  return result
}

export const fetchAllUsers = async () => {
  const url = `/users/getAllUsers`
  const result = get(url)
  return result
}

export const addRoleToUser = async (payload: Record<string, unknown>) => {
  const url = `/users/addRoleToUser`
  const result = post(url, payload)
  return result
}

export const removeRoleFromUser = async (id: string) => {
  const url = `/users/removeRoleFromUser/${id}`
  const result = remove(url)
  return result
}

export const updateRolePermission = async (
  payload: Record<string, unknown>,
) => {
  const url = `/users/updateRolePermission`
  const result = patch<Record<string, unknown>>(url, payload)
  return result
}

export const addPermissionToRole = async (payload: Record<string, unknown>) => {
  const url = `/users/addPermissionToRole`
  const result = patch<Record<string, unknown>>(url, payload)
  return result
}

export const fetchMenuItems = async () => {
  const url = `/users/menu-items`
  const result = get(url, { skipHeader: false })
  return result
}

//Case Management apis
export const fetchCaseFields = async () => {
  const url = `/salesforce/cases/caseFields`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchFilterMetadata = async () => {
  const url = `/salesforce/cases/filterMetadata`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchCases = async (payload: Record<string, unknown>) => {
  const url = `/salesforce/cases/filter`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const caseDetails = async (payload: Record<string, unknown>) => {
  const url = `/salesforce/cases/caseDetails`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const createCase = async (payload: Record<string, unknown>) => {
  const url = `/salesforce/cases/createCase`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const createCaseFields = () => {
  const url = `/salesforce/cases/createCaseFields/default`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchCategories = (payload: Record<string, string>) => {
  const url = `/salesforce/cases/createCaseFields/options`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchContacts = (payload: Record<string, unknown>) => {
  const url = `/salesforce/sites/contacts`
  return post(url, payload, { skipHeader: true })
}

export const getContactByEmail = (email: string) => {
  const url = `/contacts/by-email?emailAddress=${email}`
  return get(url)
}
//contacts tab

export const getContactColumns = () => {
  const url = `/contacts/columns`
  return get(url)
}

export const addSiteContact = (payload: Record<string, unknown>) => {
  const url = `/contacts/add-customers`
  return post(url, payload)
}
export const getContacts = (payload: Record<string, unknown>) => {
  const url = `/contacts/by-customers`
  return post(url, payload)
}

export const getContactRoleTypes = () => {
  const url = `/contacts/role-types`
  return get(url)
}

export const getContactSubscriptionType = () => {
  const url = `/contacts/subscription-types`
  return get(url)
}

export const createContact = (payload: Record<string, unknown>) => {
  const url = `/contacts/create`
  return post(url, payload)
}

export const getPerSiteOverride = (payload: Record<string, unknown>) => {
  const url = `/contacts/customers-for-contact`
  return post(url, payload)
}

export const updateContact = (payload: Record<string, unknown>) => {
  const url = `/contacts/update`
  return post(url, payload)
}
//SiteList apis

export const fetchSiteFields = async () => {
  const url = `/customer/sites/fields`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchSitesFilter = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/filter`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchSiteList = async (customerNumber: string) => {
  const url = `/salesforce/sites/${customerNumber}/siteList`
  const result = get(url, { skipHeader: true })
  return result
}

//Comments page apis

export const fetchViewComments = async (id: string) => {
  const url = `/salesforce/cases/comments/${id}?isAscending=true`
  const result = get(url, { skipHeader: true })
  return result
}

export const createComment = async (payload: Record<string, unknown>) => {
  const url = `/salesforce/cases/createComment`
  const result = post(url, payload, { skipHeader: true })
  return result
}

//dashboard apis

export const fetchCaseMetrics = async (payload: Record<string, unknown>) => {
  const url = `/salesforce/cases/dashboard/caseMetrics`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchMttrMetrics = async (payload: Record<string, unknown>) => {
  const url = `/salesforce/cases/dashboard/mttrMetrics`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchPacketLostMetrics = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/nodes/network/packetloss/metrics`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchLatencyMetrics = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/nodes/network/latency/metrics`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchOrderStatusMetrics = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/orders/dashboard-metrics`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchPreventiveAction = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/automated-actions/`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchUptimeMetrics = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/nodes/availability`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchUptimeSparkline = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/nodes/availability/sparkline`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchPreventiveDownTime = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/prevented-downtime`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchPreventiveActions = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/automated-actions/`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchEventsData = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/events`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchAlertssData = async (payload: Record<string, unknown>) => {
  const url = `/customer/cases/alerts-table`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchAlertssDescription = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/cases/alerts/description`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchGeoData = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/geomap`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchTrafficNodes = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/nodes/traffic`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchNetworkLatency = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/nodes/network/latency/graph`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchPacketLoss = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/nodes/network/packetloss/graph`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchLatencyAndPacketLoss = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/services/nodes/network-stats/graph`
  const result = post(url, payload, { skipHeader: true })
  return result
}
export const fetchCpuMemoryUsage = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/services/nodes/cpu-memory/graph`
  const result = post(url, payload, { skipHeader: true })
  return result
}
export const fetchCustomerDetails = async () => {
  const url = `/customer/sites/customerDetails`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchMapStatus = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/map/status`
  const result = post(url, payload, { skipHeader: true })
  return result
}

//siteDetails apis

export const fetchSiteNodeStatus = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/nodes/status`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchSiteNodes = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/network/devices/list`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchActiveEvents = async (payload: Record<string, unknown>) => {
  const url = `/customer/cases/alerts/active`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchDeviceData = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/nodes/graph`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchBillingBasic = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/billing/basic`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchSiteServicesExpanded = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/services`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchSalesforceServices = async (
  payload: Record<string, unknown>,
) => {
  const url = `/salesforce/sites/services`
  const result = post(url, payload, { skipHeader: true })
  return result
}
//Billing pages apis

export const fetchBillingInvoice = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/billing/invoice`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchAccountActivities = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/billing/activites`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const downloadAccountActivities = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/sites/billing/activites/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}

export const getDeviceColumns = async () => {
  const url = `/customer/sites/network/devices/list/columns`
  const result = get(url, { skipHeader: true })
  return result
}
export const downloadData = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/sites/network/devices/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}

export const downloadSiteData = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/sites/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}

export const downloadCasesData = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/salesforce/cases/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}

export const fetchCustomerSites = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/list`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetechPrimaryServices = async (
  customerNumber: string,
  siteNumber: string,
) => {
  const url = `/salesforce/sites/${customerNumber}/${siteNumber}/services`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchCustomerContacts = async (
  payload: Record<string, unknown>,
) => {
  const url = `/salesforce/sites/contacts`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchAlertsFields = async () => {
  const url = `/customer/sites/events/fields`
  const result = get(url, { skipHeader: true })
  return result
}

export const downloadBillingData = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/billing/statement/download`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const downloadBillingStatementData = async (fileId: number) => {
  const url = `/customer/sites/billing/statement/${fileId}/download`
  const result = get(url, { responseType: 'blob', skipHeader: true })
  return result
}

export const globalSearch = async (
  payload: Record<string, unknown>,
  signal?: AbortSignal,
) => {
  const url = `/customer/search`
  const result = post(url, payload, { skipHeader: true, signal })
  return result
}

export const fetchDeviceCategories = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/network/devices/categories`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchServiceCategories = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/billing/services/categories`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchSeriveBillingFilterAttributes = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/billing/services/filters`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchSeriveInventoryFilterAttributes = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/services/filters`
  const result = post(url, payload, { skipHeader: true })
  return result
}
//OrdersPage api

export const fetchOrderMetrics = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/orders/metrics
`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchOrderTable = async (
  payload: Record<string, unknown>,
  signal?: AbortSignal,
) => {
  const url = `/customer/sites/orders/list`
  const result = post(url, payload, { skipHeader: true, signal })
  return result
}

export const fetchOrderDetails = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/orders/details`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchOrderHistory = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/orders/history`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchOrderNotes = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/orders/notes`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchOrderAttachments = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/orders/attachments`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const DownloadOrderAttachments = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/sites/orders/attachments/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}
export const downloadOrders = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/sites/orders/list/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}

export const downloadServiceBilling = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/sites/billing/services/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}

export const downloadSiteService = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/sites/services/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}

export const fetchReportList = async () => {
  const url = `/customer/sites/reports`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchParentsUnderBillSubGrp = async (billsubgrp: string) => {
  const url = `/customer/sites/${billsubgrp}/parents`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchscheduledReports = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/reports/scheduled`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchStatementsByid = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/reports/statements`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchReportsData = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/reports/data`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchReportsDataByBillSubgroup = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/reports/1343/data`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchServiceBilling = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/billing/services/`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const downloadReports = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/sites/reports/data/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}

export const downloadReportsFor1343 = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/sites/reports/1343/data/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}
export const fetchOverViewSiteMetrics = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/service-delivery/overview/sites/metrics`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchBillbyServiceCharge = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/billing/statement/service/charges`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchBills = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/billing/statement/table`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchOverViewOrderMetrics = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/service-delivery/overview/orders/metrics`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchOrderInProgressStatus = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/service-delivery/overview/orders/status`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchCompletedOrders = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/service-delivery/overview/orders/completed/graph`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchVolumeGrid = async (payload: Record<string, unknown>) => {
  const url = `/customer/service-delivery/overview/orders/due/grid`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchServiceDeliverySitesMetrics = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/service-delivery/sites/metrics`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchServiceDeliverySites = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/service-delivery/sites`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const downloadServiceDeliverySites = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/service-delivery/sites/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}

export const fetchOrdersClosedPerWeek = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/service-delivery/overview/orders/weekly`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchSitesCompletedPerWeek = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/service-delivery/overview/sites/weekly`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const downloadBilling = async (fileId: number) => {
  const url = `/customer/sites/billing/statement/${fileId}/download`
  const result = get(url, { responseType: 'blob', skipHeader: true })
  return result
}

export const downloadBillStatementsexport = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/sites/billing/statement/table/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}

export const fetchBillingSummaryCards = async (
  payload: Record<string, unknown>,
): Promise<AxiosResponse<BillSummaryResponse>> => {
  const url = `/customer/sites/billing/statement/summary`
  const result = post(url, payload, {
    skipHeader: true,
  }) as Promise<AxiosResponse<BillSummaryResponse>>
  return result
}

export const fetchBillingSummarySparkline = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/billing/statement/summary/sparkline`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchBillChargesOverview = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/billing/statement/charges-overview`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchUserFields = async () => {
  const url = `/users/table/columns`
  const result = get(url)
  return result
}
export const fetchUsers = async (payload: Record<string, unknown>) => {
  const url = `/users/list`
  // const url = `/users/table`
  const result = post(url, payload)
  return result
}
// Note: If the endpint has salesforce in it, you need to pass skipHeader: true to get the response in json format

export const create_User = async (payload: Record<string, unknown>) => {
  const url = `/users/create-user`
  const result = post(url, payload)
  return result
}

export const fetchOrganizations = async (payload: Record<string, unknown>) => {
  // const url = `/users/organizations/list`
  const url = `/users/organizations/list`
  const result = post(url, payload)
  return result
}

export const fetchRolesList = async (payload: Record<string, unknown>) => {
  const url = `/users/roles/list`
  // const url = `/users/roles/table`
  const result = post(url, payload)
  return result
}

export const fetchCreateUserOptionsList = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/users/sites/options`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchChildSiteList = async (payload: Record<string, unknown>) => {
  const url = `/customer/sites/users/sites/children/options`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchBillDetailsByService = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/billing/statement/service/charges`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const BillDetailsByServiceDownload = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/sites/billing/statement/service/charges/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}

export const fetchBillsDetailsBySites = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/billing/statement/table/sites/charges`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const BillsDetailsBySitesDownload = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/sites/billing/statement/table/sites/charges/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}

export const createOrganization = async (payload: Record<string, unknown>) => {
  const url = `/users/create-organization`
  const result = post(url, payload)
  return result
}

export const fetchAssets = async () => {
  const url = `/assets/logo`
  const result = get(url)
  return result
}
export const getPaymentMethods = async (
  customerId: number,
): Promise<PaymentMethodsResponse> => {
  const url = `/revio/payments/account?customerId=${customerId}`
  const result = get(url, {
    skipHeader: true,
  }) as Promise<PaymentMethodsResponse>
  return result
}

export const deletePaymentMethod = async (paymentId: number) => {
  const url = `/revio/payments/account/delete?paymentAccountId=${paymentId}`
  const result = remove(url)
  return result
}

export const createPaymentMethod = async (payload: Record<string, unknown>) => {
  const url = `/revio/payments/accounts/create`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const createPayment = async (payload: Record<string, unknown>) => {
  const url = `/revio/payments/payment/create`
  const result = post(url, payload, { skipHeader: true })
  return result
}
export const fetchCountries = async () => {
  const url = `/revio/location/countries`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchStates = async (countryCode: string) => {
  const url = `/revio/location/states?countryCode=${countryCode}`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchCities = async (countryCode: string, stateCode: string) => {
  const url = `/revio/location/cities?countryCode=${countryCode}&stateCode=${stateCode}`
  const result = get(url, { skipHeader: true })
  return result
}

export const getPaymentDetails = async (
  customerId: number,
  paymentAccountId: number,
) => {
  const url = `/revio/payments/account/details?customerId=${customerId}&paymentAccountId=${paymentAccountId}`
  const result = get(url, { skipHeader: true })
  return result
}

export const ChargesOverviewExcel = async (statementId: string) => {
  const url = `/customer/sites/billing/statement/transactions/download`
  const fileType = 'xlsx'
  const payload = { statementId, fileType }
  const result = post(url, payload, { skipHeader: true, responseType: 'blob' })
  return result
}

export const fetchCaseCategories = async () => {
  const url = `/salesforce/cases/filter/categories`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchCaseSubCategories = async (
  payload: Record<string, unknown>,
) => {
  const url = `/salesforce/cases/filter/subcategories`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchCaseAttachments = async (
  payload: Record<string, unknown>,
) => {
  const { caseId, limit = 40, offset = 0 } = payload
  const url = `/salesforce/cases/caseAttachments?caseId=${caseId}&limit=${limit}&offset=${offset}`
  const result = get(url, { skipHeader: true })
  return result
}

export const downloadCaseAttachment = async (
  payload: Record<string, unknown>,
  type?: PostOptions,
) => {
  const { versionId } = payload
  const url = `/salesforce/cases/caseAttachments/download?versionId=${versionId}`
  const result = get(url, { responseType: 'blob', skipHeader: true, ...type })
  return result
}

export const uploadCaseAttachment = async (payload: FormData) => {
  const url = `/salesforce/cases/caseAttachments/upload`
  const result = post(url, payload as unknown as Record<string, unknown>, {
    skipHeader: true,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return result
}

export const fetchOverviewNetworkMapData = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/network/devices/map`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchOverviewDeviceHealth = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/network/devices/status/metrics`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const downloadOverviewData = async (
  payload: Record<string, unknown>,
  type: PostOptions,
) => {
  const url = `/customer/sites/network/devices/download`
  const result = post(url, payload, { skipHeader: true, ...type })
  return result
}

export const fetchBasicNodeMetrics = async (nodeId: string) => {
  const url = `/customer/sites/services/nodes/${nodeId}/basic-metrics`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchAssignedSitesForUser = async (
  payload: Record<string, unknown>,
) => {
  const url = `/customer/sites/users/sites`
  const result = post(url, payload, { skipHeader: true })
  return result
}

export const fetchUserTables = async () => {
  const url = `/users/tables`
  const result = get(url, { skipHeader: false })
  return result
}

export const fetchAllUserViews = async () => {
  const url = `/users/table-preferences/views/all`
  const result = get(url, { skipHeader: false })
  return result
}

export const createTableView = async (payload: Record<string, unknown>) => {
  const url = `/users/table-preferences/views`
  const result = post(url, payload, { skipHeader: false })
  return result
}

export const deleteUsersView = async (tableKey: string, id: string) => {
  const url = `/management/users/table-preferences/views?tableKey=${tableKey}&viewId=${id}`
  const result = remove(url)
  return result
}

export const fetchUserLoginCount = async () => {
  const url = `/users/logins-count`
  const result = get(url)
  return result
}

export const fetchCradlepointDevice = async (serialNumber: string) => {
  const url = `/customer/sites/devices/cradlepoint/device/${serialNumber}`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchCradlepointNetDevices = async (routerId: string) => {
  const url = `/customer/sites/devices/cradlepoint/device/${routerId}/net-devices`
  const result = get(url, { skipHeader: true })
  return result
}

export const fetchCradlepointNetDeviceDailyAvailability = async (
  routerId: string,
) => {
  const url = `/customer/sites/devices/cradlepoint/device/${routerId}/net-devices/availability/daily`
  const result = get(url, { skipHeader: true })
  return result
}

export const upsertBranding = async (payload: Record<string, unknown>) => {
  const url = `/users/branding`
  const result = post(url, payload, { skipHeader: false })
  return result
}

/** @deprecated Use `upsertBranding` instead */
export const createBrandingTitle = upsertBranding

export type BrandingImageType =
  | 'partner-logo'
  | 'favicon'
  | 'background-image'
  | 'nav-logo-light'
  | 'nav-logo-dark'
  | 'collapsed-menu-icon-light'
  | 'collapsed-menu-icon-dark'

export const uploadBrandingImage = async (
  file: File,
  type: BrandingImageType,
) => {
  const baseUrl = getENVData().baseURL + '/management'
  const url = `${baseUrl}/users/branding/image?type=${type}`

  const formData = new FormData()
  formData.append('file', file)

  const response: AxiosResponse = await axiosInstance.post(url, formData)
  return response
}

export const registerDomain = async (payload: Record<string, unknown>) => {
  const url = `/users/domain/register`
  const result = post(url, payload, { skipHeader: false })
  return result
}

export const verifyDomain = async (payload: Record<string, unknown>) => {
  const url = `/users/domain/verify`
  const result = post(url, payload, { skipHeader: false })
  return result
}

export const getDomain = async () => {
  const url = `/management/users/domain`
  const result = get(url, { skipHeader: true })
  return result
}

export const getBranding = async (orgId: string) => {
  const url = `/management/public/branding?org=${encodeURIComponent(orgId)}`
  const result = get(url, { skipHeader: true })
  return result
}

export const deleteDomain = async (domain: string) => {
  const baseUrl = getENVData().baseURL + '/management'
  const response = await axiosInstance.delete(`${baseUrl}/users/domain`, {
    data: { domain },
  })
  return response
}

export const deleteBrandingImage = async (type: BrandingImageType) => {
  const baseUrl = getENVData().baseURL + '/management'
  const response = await axiosInstance.delete(
    `${baseUrl}/users/branding/image?type=${type}`,
  )
  return response
}

export const deleteBranding = async () => {
  const baseUrl = getENVData().baseURL + '/management'
  const response = await axiosInstance.delete(`${baseUrl}/users/branding`)
  return response
}
